<template>
  <div v-if="loaded">
    <div autocomplete="off">
      <input
        class="searchInput"
        ref="addressSearch"
        type="text"
        placeholder="Pesquisar endereço"
        v-model="fields.address"
        autocomplete="new-password"
      />
    </div>
    <div id="map"></div>
    <b-btn :disabled="isPermissionClerk" @click="getCurrentLocation({ emitChange: true })" class="my-3">
      <i class="fas fa-location-arrow mr-2"></i>Usar minha localização
    </b-btn>
    <h4>Escolha a distância que pretende ofertar a entrega</h4>
    <div class="flex">
      <input
        :disabled="isPermissionClerk"
        id="rengeInput"
        class="range mr-2"
        v-model.number="fields.radius"
        min="1"
        max="100"
        type="range"
      />
      <input class="selector" v-model.number="fields.radius" />
      <span class="selector-h1">KM</span>
    </div>
  </div>
</template>

<script>
import { Loader } from 'google-maps';
import Axios from 'axios';

const loader = new Loader('AIzaSyA1RK-idXt1tw1QQTnrQBGYGB9o-lL_Od0', {
  libraries: ['places'],
});

export default {
  name: 'GoogleMap',
  props: {
    address: {
      type: String,
      required: false,
    },
    latitude: {
      type: Number,
      required: false,
    },
    longitude: {
      type: Number,
      required: false,
    },
    radius: {
      type: Number,
      default: 0,
    },
    localStorageKey: {
      type: String,
      required: true,
    },
    /** @type {import('google-maps').LoaderOptions} */
    options: {
      type: Object,
      default: () => ({
        disableDefaultUI: true,
        zoomControl: false,
        fullscreenControl: false,
      }),
    },
    isPermissionClerk: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data() {
    return {
      loaded: false,
      fields: {
        radius: 0,
        zoom: 9.9,
        address: '',
        latitude: 0,
        longitude: 0,
      },
    };
  },
  watch: {
    'fields.radius': function (n) {
      if (n <= 2) {
        this.fields.zoom = 14.5;
      } else if (n === 2) {
        this.fields.zoom = 13.5;
      } else if (n > 2 && n <= 5) {
        this.fields.zoom = 12.2;
      } else if (n > 5 && n <= 10) {
        this.fields.zoom = 11.2;
      } else if (n > 10 && n <= 20) {
        this.fields.zoom = 10.2;
      } else if (n > 20 && n <= 40) {
        this.fields.zoom = 9.2;
      } else if (n > 40 && n <= 60) {
        this.fields.zoom = 8.6;
      } else if (n > 60 && n <= 80) {
        this.fields.zoom = 8.2;
      } else if (n > 80 && n <= 120) {
        this.fields.zoom = 7.9;
      } else if (n > 120 && n <= 200) {
        this.fields.zoom = 7;
      } else if (n > 200 && n <= 300) {
        this.fields.zoom = 6.5;
      } else if (n > 300 && n <= 500) {
        this.fields.zoom = 5.5;
      }

      this.$emit('update:radius', parseInt(this.fields.radius, 10));
    },
    'fields.address': function () {
      this.$emit('update:address', this.fields.address);
      this.buildGoogleMap();
    },
    'fields.latitude': function () {
      this.$emit('update:latitude', parseFloat(this.fields.latitude));
    },
    'fields.longitude': function () {
      this.$emit('update:longitude', parseFloat(this.fields.longitude));
    },
  },
  mounted() {
    this.fields.address = this.address;
    this.fields.radius = parseInt(this.radius, 10);
    this.fields.latitude = parseFloat(this.latitude);
    this.fields.longitude = parseFloat(this.longitude);

    this.$nextTick(async () => {
      await this.handleCurrentAddress();
      await this.buildGoogleMap();
    });

    this.loaded = true;
  },
  methods: {
    async handleCurrentAddress() {
      if (this.fields.address) return;

      if (!this.fields.latitude || !this.fields.longitude) {
        await this.getCurrentLocation({});
        return;
      }

      this.populateMap();
    },
    async buildGoogleMap() {
      const google = await loader.load();

      await this.getLocalizationPermission();

      const latitudeAndLongitude = await new google.maps.LatLng(
        this.fields.latitude,
        this.fields.longitude
      );

      const map = new google.maps.Map(document.getElementById('map'), {
        zoom: this.fields.zoom,
        gestureHandling: 'none',
        center: latitudeAndLongitude,
        options: this.options,
      });

      google.maps.event.trigger(map, 'resize');

      setInterval(() => {
        map.setZoom(this.fields.zoom);
      }, 800);

      const circle = new google.maps.Circle({
        center: latitudeAndLongitude,
        map,
        radius: this.fields.radius,
        strokeColor: '#EE731F',
        strokeOpacity: 0.6,
        strokeWeight: 1,
        fillColor: '#EE731F',
        fillOpacity: 0.3,
      });

      const marker = new google.maps.Marker({
        position: latitudeAndLongitude,
        map,
      });

      const autocomplete = new google.maps.places.Autocomplete(
        document.querySelector('.searchInput')
      );

      setInterval(() => {
        let radiusToSet = parseFloat(this.fields.radius) * 1000;
        radiusToSet = Number.isNaN(radiusToSet) ? 1 : radiusToSet;
        circle.setRadius(radiusToSet || 1);
      }, 10);

      this.handlePlaceChange(autocomplete, map, marker, circle);
    },
    /**
     * @param {google.maps.places.Autocomplete} input
     * @param {google.maps.Map<HTMLElement>} map
     * @param {google.maps.Marker} marker
     * @param {google.maps.Circle} circle
     */
    async handlePlaceChange(input, map, marker, circle) {
      input.addListener('place_changed', async () => {
        const place = input.getPlace();

        this.fields.address = place.formatted_address;
        
        if (place.geometry.viewport) {
          map.fitBounds(place.geometry.viewport);
        } else {
          map.setCenter(place.geometry.location);
          map.setZoom(this.fields.zoom);
        }

        this.fields.latitude = place.geometry.location.lat();
        
        this.fields.longitude = place.geometry.location.lng();
       
        map.setCenter(place.geometry.location);
        marker.setPosition(place.geometry.location);
        marker.setVisible(true);

        circle.setCenter(place.geometry.location);

        map.setZoom(this.fields.zoom);

        circle.setRadius(parseFloat(this.fields.radius) * 1000);
        circle.setVisible(true);
      });
    },
    async getLocalizationPermission() {
      if (this.fields.latitude && this.fields.longitude) return;

      await navigator.permissions
        .query({ name: 'geolocation' })
        .then(async (result) => {
          if (result.state !== 'prompt') return;

          await this.getCurrentLocation({});
        });
    },
    async getCurrentLocation({ emitChange = false }) {
      navigator.geolocation.getCurrentPosition(async (res) => {
        this.fields.latitude = res.coords.latitude;
        
        this.fields.longitude = res.coords.longitude;
        
        await this.populateMap();

        if (emitChange)
          this.$refs.addressSearch.dispatchEvent(new Event('place_changed'));
      });
    },
    async populateMap() {
      const response = await this.getCitiesByCoords();

      this.fields.address = response.formatted;
    },
    async getCitiesByCoords() {
      if (!this.fields.latitude || !this.fields.longitude) return {};

      const queryString = `${this.fields.latitude}+${this.fields.longitude}`;

      const getCitiesResponse = await Axios.get(
        `https://api.opencagedata.com/geocode/v1/json?q=${queryString}&key=610f77b3d3d24bc384a962a9a35895fb`
      );

      return getCitiesResponse.data.results[0] || {};
    },
  },
};
</script>

<style scoped>
.searchInput {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  padding: 0 15px;
  width: calc(95% - 30px);
  height: 35px;

  border-radius: 10px;
  border: 2px solid #EE731F;
}
</style>